// Lightweight event tracking client.
// Fire-and-forget — never blocks UI, never throws to caller.
// Session id is persisted in sessionStorage so all events in one visit correlate.

const LOCAL_API = 'http://localhost:3001';
const api = process.env.NODE_ENV === 'production' ? '' : LOCAL_API;

function getSid() {
  try {
    let sid = sessionStorage.getItem('nr_sid');
    if (!sid) {
      sid = Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-6);
      sessionStorage.setItem('nr_sid', sid);
    }
    return sid;
  } catch {
    return null;
  }
}

export function track(name, props) {
  try {
    const body = JSON.stringify({ name, props: props || {}, sid: getSid() });
    // Prefer sendBeacon on unload paths; fall back to fetch with keepalive
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(`${api}/api/track`, blob);
      return;
    }
    fetch(`${api}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {}
}

export function pageview(path) {
  track('pageview', { path: path || (typeof window !== 'undefined' ? window.location.pathname : '') });
}
